import { GetterTree } from 'vuex';

import { ModulesStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<ModulesStateI, RootStateI> = {
};
